import { last, values } from "lodash";
import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";
import { GLOBAL_ENTRY_SELECT_VALUES } from "./geSchema";

export const CHINA_SELECT_VALUES = {
  MARITAL_STATUS: "MARITAL_STATUS",
  PASSPORT_TYPE: "PASSPORT_TYPE",
  VISA_TYPES: "VISA_TYPES",
  OCCUPATION_TYPE: "OCCUPATION_TYPE",
  DIPLOMAS: "DIPLOMAS",
  ENTRANCE_OPTION: "ENTRANCE_OPTION",
  TOURIST_TYPE: "TOURIST_TYPE",
  WORK_VISA_TYPE: "WORK_VISA_TYPE",
  GENDER_TYPE: "GENDER_TYPE",
  COUNTRIES: "COUNTRIES",
  VISA_VALIDITY: "VISA_VALIDITY",
  EDUCATION_LEVEL: "EDUCATION_LEVEL",
  STATUS_IN_CHINA: "STATUS_IN_CHINA",
  SECURITY_QUESTION: "SECURITY_QUESTION",
  VALID_VISA_TIMES: "VALID_VISA_TIMES",
  WHO_PAYS_FOR_VISA: "WHO_PAYS_FOR_VISA",
  COUNTRIES_LABELS: "COUNTRIES_LABELS",
};

export const chinaSchema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      applicantNumber: {
        label: "Applicant number",
        type: TYPES.TEXT,
      },
      siteId: {
        label: "Referral Site",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID History",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      botRuns: {
        label: "Number of bot runs",
      },
      userEmail: {
        label: "User contact email",
        type: TYPES.EMAIL,
      },
      submissionEmail: {
        label: "User submission email",
        type: TYPES.TEXT,
      },
    },
  },
  personal_information: {
    label: "Personal information",
    type: TYPES.SEGMENT,
    data: {
      firstName: {
        label: "Given name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Surname",
        type: TYPES.TEXT,
        required: true,
      },
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.GENDER_TYPE,
        required: true,
      },
      hasOtherNames: {
        label: "Other name(s) or Former name(s)",
        type: TYPES.CHECKBOX,
      },
      otherNames: {
        label: "Other name(s) or Former name(s)",
        type: TYPES.TEXT,
        dependsOn: "hasOtherNames",
      },
      hasChineseName: {
        label: "Chinese name",
        type: TYPES.CHECKBOX,
      },
      chineseName: {
        label: "Chinese name",
        type: TYPES.TEXT,
        dependsOn: "hasChineseName",
      },
      maritalStatus: {
        label: "Marital status",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.MARITAL_STATUS,
        value: "$value",
        required: true,
      },
      maritalStatusDescription: {
        label: "Marital status details",
        type: TYPES.TEXT,
        dependsOn: "maritalStatus",
        dependantOnValues: ["Other"],
      },
      spouseInfo: {
        label: "Spouse",
        type: TYPES.NESTED,
        dependsOn: "maritalStatus",
        newTable: true,
        dependantOnValues: ["Married"],
        nested: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          nationality: {
            label: "Nationality",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          countryOfBirth: {
            label: "Country of birth",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          cityOfBirth: {
            label: "City of birth",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            path: "spouseInfo",
            dependantOnValues: ["Married"],
          },
          address: {
            label: "Address",
            type: TYPES.TEXT,
            dependsOn: "maritalStatus",
            dependantOnValues: ["Married"],
            path: "spouseInfo",
          },
          isApplicantAddress: {
            label: "Is the spouse's address the same as applicant's?",
            type: TYPES.CHECKBOX,
            dependsOn: "maritalStatus",
            dependantOnValues: ["Married"],
            path: "spouseInfo",
          },
        },
      },
      dateOfBirth: {
        label: "Date of birth",
        type: TYPES.DATE,
        required: true,
      },
      birthCountry: {
        label: "Country",
        type: TYPES.TEXT,
        required: true,
      },
      birthState: {
        label: "State",
        type: TYPES.TEXT,
        required: true,
      },
      birthCity: {
        label: "City",
        type: TYPES.TEXT,
        required: true,
      },
      residenceCountry: {
        label: "Residence country",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
      },
      residenceAddress: {
        label: "Residence address",
        type: TYPES.TEXT,
        required: true,
      },
      phoneNumber: {
        label: "Phone number",
        type: TYPES.TEXT,
        required: true,
      },
      nationalityOnPassport: {
        label: "Nationality on passport",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      nationalIdNumber: {
        label: "National ID number",
        type: TYPES.TEXT,
        required: true,
      },
      hasOtherNationality: {
        label: "Do you hold any other nationality?",
        type: TYPES.CHECKBOX,
      },
      otherNationalities: {
        label: "Other nationalities",
        type: TYPES.ARRAY,
        dependsOn: "hasOtherNationality",
        data: {
          country: {
            label: "Country",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.COUNTRIES,
            path: "otherNationalities.$otherNationalities",
          },
          idNumberAvailable: {
            label: "ID number of other nationality",
            type: TYPES.CHECKBOX,
            path: "otherNationalities.$otherNationalities",
            stringToBoolean: {
              trueValue: "Available",
              falseValue: "Not available",
            },
          },
          idNumber: {
            label: "ID number",
            type: TYPES.TEXT,
            dependsOn:
              "otherNationalities.$otherNationalities.idNumberAvailable",
            path: "otherNationalities.$otherNationalities",
            dependantOnValues: ["Available"],
          },
          idNumberDetails: {
            label: "No ID number details",
            type: TYPES.TEXT,
            dependsOn:
              "otherNationalities.$otherNationalities.idNumberAvailable",
            path: "otherNationalities.$otherNationalities",
            dependantOnValues: ["Not available"],
          },
          passportNumberAvailable: {
            label: "Passport number of other nationality",
            type: TYPES.CHECKBOX,
            path: "otherNationalities.$otherNationalities",
            stringToBoolean: {
              trueValue: "Available",
              falseValue: "Not available",
            },
          },
          passportNumber: {
            label: "Passport number",
            type: TYPES.TEXT,
            dependsOn:
              "otherNationalities.$otherNationalities.passportNumberAvailable",
            path: "otherNationalities.$otherNationalities",
            dependantOnValues: ["Available"],
          },
          passportNumberDetails: {
            label: "No passport number details",
            type: TYPES.TEXT,
            dependsOn:
              "otherNationalities.$otherNationalities.passportNumberAvailable",
            path: "otherNationalities.$otherNationalities",
            dependantOnValues: ["Not available"],
          },
        },
      },
      hasPermanentResidence: {
        label:
          "Do you have permanent residence of any other country or region?",
        type: TYPES.CHECKBOX,
      },
      permanentResidenceCountry: {
        label: "Country of permanent residence",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
        dependsOn: "hasPermanentResidence",
      },
      heldOtherNationality: {
        label: "Have you ever held any other nationality?",
        type: TYPES.CHECKBOX,
      },
      previousNationality: {
        label: "Previous nationality",
        type: TYPES.TEXT,
        dependsOn: "heldOtherNationality",
      },
      passportType: {
        label: "Passport type",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.PASSPORT_TYPE,
        value: "$value",
        required: true,
      },
      passportTypeDescription: {
        label: "Passport type details",
        type: TYPES.TEXT,
        dependsOn: "passportType",
        dependantOnValues: ["Other"],
      },
      passportCountryOfIssue: {
        label: "Country of issue",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      passportPlaceOfIssue: {
        label: "Place of issue",
        type: TYPES.TEXT,
        required: true,
      },
      passportExpirationDate: {
        label: "Passport expiration date",
        type: TYPES.DATE,
        required: true,
      },
      passportNumber: {
        label: "Passport number",
        type: TYPES.TEXT,
        required: true,
      },
    },
  },
  visa_information: {
    label: "Visa information",
    type: TYPES.SEGMENT,
    data: {
      country: {
        label: "Country or region",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      consulate: {
        label: "Embassy / consulate",
        type: TYPES.TEXT,
        required: true,
      },
      visaType: {
        label: "Visa type",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.VISA_TYPES,
        value: "$value",
        required: true,
      },
      entranceOption: {
        label: "Entrance option",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.ENTRANCE_OPTION,
        value: "$value",
        required: true,
      },
      maxDurationOfStay: {
        label: "Maximum duration of longest stay (days)",
        type: TYPES.NUMBER,
        required: true,
      },
      visaValidity: {
        label: "Validity of visa",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.VISA_VALIDITY,
        value: "$value",
        required: true,
      },
      touristType: {
        label: "Tourist type",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.TOURIST_TYPE,
        value: "$value",
        required: true,
      },
      travelAgencyName: {
        label: "Travel agency name",
        type: TYPES.TEXT,
        dependsOn: "touristType",
        dependantOnValues: ["Grouped"],
      },
      travelAgencyLicenseNumber: {
        label: "Travel agency license ID",
        type: TYPES.TEXT,
        dependsOn: "touristType",
        dependantOnValues: ["Grouped"],
      },
      workVisaType: {
        label: "Work visa type",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.WORK_VISA_TYPE,
        value: "$value",
        dependsOn: "visaType",
        dependantOnValues: ["Work (Z)"],
      },
    },
  },
  work_and_education_information: {
    label: "Work and education information",
    type: TYPES.SEGMENT,
    data: {
      visaType: {
        label: "Visa type",
        type: TYPES.SELECT,
        value: "$value",
        values: CHINA_SELECT_VALUES.VISA_TYPES,
        required: true,
      },
      occupation: {
        label: "Occupation",
        type: TYPES.SELECT,
        value: "$value",
        values: CHINA_SELECT_VALUES.OCCUPATION_TYPE,
        required: true,
      },
      otherOccupationDetail: {
        label: "Other occupation details",
        type: TYPES.TEXT,
        dependsOn: "occupation",
        dependantOnValues: ["Other"],
      },
      educationNotApplicable: {
        label: "Not applicable",
        type: TYPES.CHECKBOX,
      },
      schoolName: {
        label: "School / university name",
        type: TYPES.TEXT,
        dependsOn: "educationNotApplicable",
        dependantOnValues: [false],
      },
      diploma: {
        label: "Diploma / degree",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.EDUCATION_LEVEL,
        dependsOn: "educationNotApplicable",
        dependantOnValues: [false],
      },
      major: {
        label: "Major",
        type: TYPES.TEXT,
        dependsOn: "educationNotApplicable",
        dependantOnValues: [false],
      },
      educationDetails: {
        label: "Education details",
        type: TYPES.TEXT,
        dependsOn: "educationNotApplicable",
        dependantOnValues: [true],
      },
      workExperienceNotApplicable: {
        label: "Not applicable",
        type: TYPES.CHECKBOX,
      },
      workExperienceDetails: {
        label: "Work experience details",
        type: TYPES.TEXT,
        dependsOn: "workExperienceNotApplicable",
        dependantOnValues: [true],
      },
      workExperience: {
        label: "Work experience",
        type: TYPES.ARRAY,
        dependsOn: "workExperienceNotApplicable",
        dependantOnValues: [false],
        data: {
          employmentStartDate: {
            label: "Employment start date",
            type: TYPES.DATE,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          employmentEndDate: {
            label: "Employment end date",
            type: TYPES.DATE,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          employerName: {
            label: "Employer name",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          employerAddress: {
            label: "Employer address",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          employerPhone: {
            label: "Employer phone number",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          position: {
            label: "Your position",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          duty: {
            label: "Your duty",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          supervisorName: {
            label: "Supervisor name",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
          supervisorPhone: {
            label: "Supervisor phone number",
            type: TYPES.TEXT,
            dependsOn: "workExperienceNotApplicable",
            dependantOnValues: [false],
            path: "workExperience.$workExperience",
          },
        },
      },
    },
  },
  family_information: {
    label: "Family information",
    type: TYPES.SEGMENT,
    data: {
      father: {
        label: "Father",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          notApplicable: {
            label: "Not applicable",
            type: TYPES.CHECKBOX,
            path: "father",
          },
          details: {
            label: "Specify details",
            type: TYPES.TEXT,
            dependsOn: "notApplicable",
            path: "father",
            dependantOnValues: [true],
          },
        },
      },
      fatherInfo: {
        label: "Father info",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "father.notApplicable",
        dependantOnValues: [false],
        nested: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "father",
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "father",
          },
          nationality: {
            label: "Nationality",
            type: TYPES.TEXT,
            path: "father",
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            path: "father",
          },
          isInChina: {
            label: "Is your father in China?",
            type: TYPES.CHECKBOX,
            path: "father",
          },
          statusInChina: {
            label: "Status in China",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.STATUS_IN_CHINA,
            value: "$value",
            dependsOn: "isInChina",
            dependantOnValues: [true],
          },
          visaValidityOption: {
            label: "Specify details",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.VALID_VISA_TIMES,
            dependsOn: "statusInChina",
            value: "$value",
            dependantOnValues: ["Permanent resident", "Resident", "Stay"],
          },
        },
      },
      mother: {
        label: "Mother",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          notApplicable: {
            label: "Not applicable",
            type: TYPES.CHECKBOX,
            path: "mother",
          },
        },
      },
      motherNotApplicable: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "mother.notApplicable",
        dependantOnValues: [true],
        newTable: true,
        nested: {
          details: {
            label: "Specify details",
            type: TYPES.TEXT,
            path: "mother",
          },
        },
      },
      motherInfo: {
        label: "Mother info",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "mother.notApplicable",
        dependantOnValues: [false],
        nested: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "mother",
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "mother",
          },
          nationality: {
            label: "Nationality",
            type: TYPES.TEXT,
            path: "mother",
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            path: "mother",
          },
          isInChina: {
            label: "Is your mother in China?",
            type: TYPES.CHECKBOX,
            path: "mother",
          },
          statusInChina: {
            label: "Status in China",
            type: TYPES.SELECT,
            value: "$value",
            values: CHINA_SELECT_VALUES.STATUS_IN_CHINA,
            dependsOn: "isInChina",
            dependantOnValues: [true],
          },
          visaValidityOption: {
            label: "Specify details",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.VALID_VISA_TIMES,
            dependsOn: "statusInChina",
            value: "$value",
            dependantOnValues: ["Permanent resident", "Resident", "Stay"],
          },
        },
      },
      childrenSection: {
        label: "Children",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          notApplicable: {
            label: "Not applicable",
            type: TYPES.CHECKBOX,
            path: "childrenSection",
          },
        },
      },
      childrenNotApplicable: {
        label: "Specify details",
        type: TYPES.NESTED,
        dependsOn: "childrenSection.notApplicable",
        dependantOnValues: [true],
        newTable: true,
        nested: {
          details: {
            label: "Specify details",
            type: TYPES.TEXT,
            path: "childrenSection",
          },
        },
      },
      childrenInfo: {
        label: "Children info",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "childrenSection.notApplicable",
        dependantOnValues: [false],
        nested: {
          children: {
            label: "Children",
            type: TYPES.ARRAY,
            path: "childrenSection",
            data: {
              givenName: {
                label: "Given name",
                type: TYPES.TEXT,
                path: "childrenSection.children.$children",
              },
              surname: {
                label: "Surname",
                type: TYPES.TEXT,
                path: "childrenSection.children.$children",
              },
              nationality: {
                label: "Nationality",
                type: TYPES.TEXT,
                path: "childrenSection.children.$children",
              },
              dateOfBirth: {
                label: "Date of birth",
                type: TYPES.DATE,
                path: "childrenSection.children.$children",
              },
            },
          },
        },
      },
      hasRelativesInChina: {
        label:
          "Do you have any immediate relatives, not including parents, in China?",
        type: TYPES.CHECKBOX,
      },
      relativesInChina: {
        label: "Relatives in China",
        type: TYPES.ARRAY,
        dependsOn: "hasRelativesInChina",
        dependantOnValues: [true],
        data: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "relativesInChina.$relativesInChina",
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "relativesInChina.$relativesInChina",
          },
          statusInChina: {
            label: "Status in China",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.STATUS_IN_CHINA,
            value: "$value",
            path: "relativesInChina.$relativesInChina",
          },
          visaValidityOption: {
            label: "Specify details",
            type: TYPES.SELECT,
            dependsOn: "statusInChina",
            path: "relativesInChina.$relativesInChina",
            value: "$value",
            dependantOnValues: ["Permanent resident", "Resident", "Stay"],
            values: CHINA_SELECT_VALUES.VALID_VISA_TIMES,
          },
        },
      },
    },
  },
  trip_information: {
    label: "Trip information",
    type: TYPES.SEGMENT,
    data: {
      arrivalInfo: {
        label: "Arrival information",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          dateOfArrival: {
            label: "Date of arrival",
            type: TYPES.DATE,
            required: true,
            path: "arrivalInfo",
          },
          transportNumber: {
            label: "Transport number",
            type: TYPES.TEXT,
            required: true,
            path: "arrivalInfo",
          },
          city: {
            label: "City of arrival",
            type: TYPES.TEXT,
            required: true,
            path: "arrivalInfo",
          },
          district: {
            label: "District of arrival",
            type: TYPES.TEXT,
            required: true,
            path: "arrivalInfo",
          },
        },
      },
      departureInfo: {
        label: "Departure information",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          dateOfDeparture: {
            label: "Date of departure",
            type: TYPES.DATE,
            required: true,
            path: "departureInfo",
          },
          transportNumber: {
            label: "Transport number",
            type: TYPES.TEXT,
            required: true,
            path: "departureInfo",
          },
          city: {
            label: "City of departure",
            type: TYPES.TEXT,
            required: true,
            path: "departureInfo",
          },
          district: {
            label: "District of departure",
            type: TYPES.TEXT,
            required: true,
            path: "departureInfo",
          },
        },
      },
      itinerary: {
        label: "Itinerary",
        type: TYPES.ARRAY,
        data: {
          city: {
            label: "City",
            type: TYPES.TEXT,
            path: "itinerary.$itinerary",
          },
          address: {
            label: "Address",
            type: TYPES.TEXT,
            path: "itinerary.$itinerary",
          },
          dateOfArrival: {
            label: "Arrival date",
            type: TYPES.DATE,
            path: "itinerary.$itinerary",
          },
          dateOfDeparture: {
            label: "Departure date",
            type: TYPES.DATE,
            path: "itinerary.$itinerary",
          },
        },
      },
      emergencyContact: {
        label: "Emergency contact",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            required: true,
            path: "emergencyContact",
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            required: true,
            path: "emergencyContact",
          },
          relationship: {
            label: "Relationship",
            type: TYPES.TEXT,
            required: true,
            path: "emergencyContact",
          },
          phoneNumber: {
            label: "Phone number",
            type: TYPES.TEXT,
            required: true,
            path: "emergencyContact",
          },
          email: {
            label: "Email",
            type: TYPES.EMAIL,
            required: true,
            path: "emergencyContact",
          },
        },
      },
      invitingPartyInfo: {
        label: "Inviting party info",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          name: {
            label: "Name",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
          relationship: {
            label: "Relationship",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
          phoneNumber: {
            label: "Phone number",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
          email: {
            label: "Email",
            type: TYPES.EMAIL,
            path: "invitingParty",
          },
          province: {
            label: "Province",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
          city: {
            label: "City",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
          postCode: {
            label: "Post code",
            type: TYPES.TEXT,
            path: "invitingParty",
          },
        },
      },
      additionalInfo: {
        label: "Additional information",
        type: TYPES.NESTED,
        nested: {
          hasAccompanyingPerson: {
            label: "Do you have accompanying person(s)?",
            type: TYPES.CHECKBOX,
            path: "additionalInfo",
          },
          whoPays: {
            label: "Who pays for your trip?",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.WHO_PAYS_FOR_VISA,
            value: "$value",
            path: "additionalInfo",
          },
        },
      },
      payForVisa: {
        label: "Who pays for the visa?",
        type: TYPES.NESTED,
        dependsOn: "additionalInfo.whoPays",
        dependantOnValues: ["Organization", "Other"],
        newTable: true,
        nested: {
          name: {
            label: "Name",
            type: TYPES.TEXT,
            dependsOn: "additionalInfo.whoPays",
            dependantOnValues: ["Organization", "Other"],
            path: "additionalInfo",
          },
          relationship: {
            label: "Relationship to you",
            type: TYPES.TEXT,
            dependsOn: "additionalInfo.whoPays",
            dependantOnValues: ["Organization"],
            path: "additionalInfo",
          },
          address: {
            label: "Address",
            type: TYPES.TEXT,
            dependsOn: "additionalInfo.whoPays",
            dependantOnValues: ["Organization"],
            path: "additionalInfo",
          },
          country: {
            label: "Country",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.COUNTRIES,
            dependsOn: "additionalInfo.whoPays",
            dependantOnValues: ["Organization"],
            path: "additionalInfo",
          },
          phoneNumber: {
            label: "Phone number",
            type: TYPES.TEXT,
            dependsOn: "additionalInfo.whoPays",
            dependantOnValues: ["Other"],
            path: "additionalInfo",
          },
        },
      },
      accompanyingPerson: {
        type: TYPES.ARRAY,
        path: "additionalInfo",
        label: "Accompanying person(s)",
        dependsOn: "additionalInfo.hasAccompanyingPerson",
        required: true,
        dependantOnValues: [true],
        data: {
          givenName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "additionalInfo.accompanyingPerson.$accompanyingPerson",
          },
          surname: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "additionalInfo.accompanyingPerson.$accompanyingPerson",
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            path: "additionalInfo.accompanyingPerson.$accompanyingPerson",
          },
          gender: {
            label: "Gender",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.GENDER_TYPE,
            value: "$value",
            path: "additionalInfo.accompanyingPerson.$accompanyingPerson",
          },
        },
      },
    },
  },
  past_travels: {
    label: "Past travels",
    type: TYPES.SEGMENT,
    data: {
      hasBeenToChina: {
        label: "Have you ever been to China?",
        type: TYPES.CHECKBOX,
      },
      hadChineseVisa: {
        label: "Have you been issued a Chinese visa?",
        type: TYPES.CHECKBOX,
      },
      chineseVisaInfo: {
        label: "Chinese visa information",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "hadChineseVisa",
        dependantOnValues: [true],
        nested: {
          visaType: {
            label: "Visa type",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.VISA_TYPES,
            value: "$value",
          },
          visaNumber: {
            label: "Visa number",
            type: TYPES.TEXT,
          },
          placeOfIssue: {
            label: "Place of issue",
            type: TYPES.TEXT,
          },
          dateOfIssue: {
            label: "Place of issue",
            type: TYPES.DATE,
          },
          hasBeenFingerprinted: {
            label: "Have you ever been fingerprinted in China?",
            type: TYPES.CHECKBOX,
          },
          countryOfFingerprint: {
            label: "Country of fingerprinting",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.COUNTRIES,
            dependsOn: "hasBeenFingerprinted",
            dependantOnValues: [true],
          },
          cityOfFingerprint: {
            label: "City of fingerprinting",
            type: TYPES.TEXT,
            dependsOn: "hasBeenFingerprinted",
            dependantOnValues: [true],
          },
          fingerprintDate: {
            label: "Date of fingerprinting",
            type: TYPES.DATE,
            dependsOn: "hasBeenFingerprinted",
            dependantOnValues: [true],
          },
          hasResidencePermit: {
            label: "Do you have a residence permit?",
            type: TYPES.CHECKBOX,
          },
          residencePermitNumber: {
            label: "Residence permit number",
            type: TYPES.TEXT,
            dependsOn: "hasResidencePermit",
            dependantOnValues: [true],
          },
        },
      },
      hasOtherValidVisas: {
        label:
          "Do you currently hold any valid visas issued by other countries?",
        type: TYPES.CHECKBOX,
      },
      otherValidVisaCountries: {
        label: "Other valid visa countries",
        dependsOn: "hasOtherValidVisas",
        dependantOnValues: [true],
        type: TYPES.MULTI_SELECT,
        values: CHINA_SELECT_VALUES.COUNTRIES,
        value: "$value",
      },
      hasVisitedOtherCountries: {
        label:
          "Have you visited other countries or regions in the last 12 months?",
        type: TYPES.CHECKBOX,
      },
      visitedCountries: {
        label: "Country",
        type: TYPES.MULTI_SELECT,
        dependsOn: "hasVisitedOtherCountries",
        dependantOnValues: [true],
        values: CHINA_SELECT_VALUES.COUNTRIES,
      },
    },
  },
  security_questions: {
    label: "Security questions",
    type: TYPES.SEGMENT,
    data: {
      refusedVisa: {
        label:
          "Have you ever been refused a visa for China, or been refused entry into China?",
        type: TYPES.CHECKBOX,
      },
      refusedVisaDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "refusedVisa",
        dependantOnValues: [true],
      },
      visaCancelled: {
        label: "Has your Chinese visa ever been cancelled?",
        type: TYPES.CHECKBOX,
      },
      visaCancelledDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "visaCancelled",
        dependantOnValues: [true],
      },
      illegalEntryOrWork: {
        label:
          "Have you ever entered China illegally, overstayed, or worked illegally?",
        type: TYPES.CHECKBOX,
      },
      illegalEntryOrWorkDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "illegalEntryOrWork",
        dependantOnValues: [true],
      },
      criminalRecord: {
        label: "Do you have any criminal record in China or any other country?",
        type: TYPES.CHECKBOX,
      },
      criminalRecordDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "criminalRecord",
        dependantOnValues: [true],
      },
      mentalOrInfectiousDisease: {
        label: "Do you have any serious mental disorder or infectious disease?",
        type: TYPES.CHECKBOX,
      },
      mentalOrInfectiousDiseaseDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "mentalOrInfectiousDisease",
        dependantOnValues: [true],
      },
      epidemicTravel: {
        label:
          "Have you ever visited countries or territories where there is an epidemic in the last 30 days?",
        type: TYPES.CHECKBOX,
      },
      epidemicTravelDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "epidemicTravel",
        dependantOnValues: [true],
      },
      firearmsOrExplosivesTraining: {
        label:
          "Have you ever been trained or do you have any special skills in the field of firearms, explosives, nuclear devices, biological or chemical products?",
        type: TYPES.CHECKBOX,
      },
      firearmsOrExplosivesTrainingDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "firearmsOrExplosivesTraining",
        dependantOnValues: [true],
      },
      militaryService: {
        label: "Are you serving or have you ever served in the military?",
        type: TYPES.CHECKBOX,
      },
      militaryServiceEntries: {
        label: "Military experience",
        type: TYPES.ARRAY,
        dependsOn: "militaryService",
        dependantOnValues: [true],
        data: {
          country: {
            label: "Country",
            type: TYPES.SELECT,
            values: CHINA_SELECT_VALUES.COUNTRIES,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
          branch: {
            label: "Branch of service",
            type: TYPES.TEXT,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
          rank: {
            label: "Rank in military",
            type: TYPES.TEXT,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
          specialty: {
            label: "Military specialty",
            type: TYPES.TEXT,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
          startDate: {
            label: "Start date",
            type: TYPES.DATE,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
          endDate: {
            label: "End date",
            type: TYPES.DATE,
            path: "militaryServiceEntries.$militaryServiceEntries",
          },
        },
      },
      paramilitaryService: {
        label:
          "Have you served or participated in any paramilitary organization, civil armed units, guerrilla forces or armed organizations, or been its member?",
        type: TYPES.CHECKBOX,
      },
      paramilitaryServiceDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "paramilitaryService",
        dependantOnValues: [true],
      },
      professionalOrgMembership: {
        label:
          "Do you work for any professional, social or charitable organization?",
        type: TYPES.CHECKBOX,
      },
      professionalOrgMembershipDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "professionalOrgMembership",
        dependantOnValues: [true],
      },
      anythingElseToDeclare: {
        label: "Is there anything else you want to declare?",
        type: TYPES.CHECKBOX,
      },
      anythingElseToDeclareDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "anythingElseToDeclare",
        dependantOnValues: [true],
      },
      familyInMilitaryOrLaw: {
        label:
          "Are you or your family members serving or have ever served in the military or law-enforcement department?",
        type: TYPES.CHECKBOX,
      },
      familyInMilitaryOrLawDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "familyInMilitaryOrLaw",
        dependantOnValues: [true],
      },
      familyInPolitics: {
        label:
          "Do you or your family members belong to or have ever belonged to any political parties or groups?",
        type: TYPES.CHECKBOX,
      },
      familyInPoliticsDetails: {
        label: "Specify details",
        type: TYPES.TEXT,
        dependsOn: "familyInPolitics",
        dependantOnValues: [true],
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security question",
        type: TYPES.SELECT,
        values: CHINA_SELECT_VALUES.SECURITY_QUESTION,
        value: "$value",
      },
      securityAnswer: {
        label: "Answer",
        type: TYPES.TEXT,
        required: true,
      },
      applicantSignature: {
        label: "Applicant signature",
        type: TYPES.TEXT,
        required: true,
      },
      agreeDeclaration: {
        label: "I agree to the declaration",
        type: TYPES.CHECKBOX,
        required: true,
      },
      agreeTerms: {
        label: "I agree to the terms and conditions",
        type: TYPES.CHECKBOX,
        required: true,
      },
      guardianConsent: {
        label: "Guardian consent",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          parentFullName: {
            label: "Parent / guardian full name",
            type: TYPES.TEXT,
            path: "guardianConsent",
          },
          signature: {
            label: "Signature",
            type: TYPES.TEXT,
            path: "guardianConsent",
          },
        },
      },
    },
  },
};
